import { cva } from "class-variance-authority";

export const dialogVariants = cva(
  [
    // Transition
    "duration-100 ease-out data-[closed]:opacity-0",

    // Layout
    "row-start-2 w-full min-w-0 max-h-full overflow-auto",

    // Background
    "bg-primary",

    // Effects
    "rounded-t-3xl sm:rounded-2xl",
    "shadow-lg ring-1 ring-accent",
    "transition-all",

    // Spacing
    "[--gutter:theme(spacing.8)]",
    "p-[--gutter] sm:mb-auto",

    // Forced colors
    "forced-colors:outline",
  ],
  {
    variants: {
      size: {
        xs: "sm:max-w-xs",
        sm: "sm:max-w-sm",
        md: "sm:max-w-md",
        lg: "sm:max-w-lg",
        xl: "sm:max-w-xl",
        "2xl": "sm:max-w-2xl",
        "3xl": "sm:max-w-3xl",
        "4xl": "sm:max-w-4xl",
        "5xl": "sm:max-w-5xl",
      },
    },
  },
);
